<template>
    <v-layout>
        <v-dialog v-model="isShowDialog" max-width="35rem">
            <v-card>
                <v-card-title class="secondary elevation-4 white--text">
                    <div class="text-h5">
                        <v-icon class="pb-1" color="white" medium> fa-trash-alt </v-icon>
                        {{ dialogHeader }}
                    </div>
                </v-card-title>
                <v-card-text class="message pa-4">
                    <slot name="dialogMessage" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <button-app-control ref="cancel-btn" :label="$t('Cancel')" text @click="closeDialog()" />
                    <button-app-control ref="submit-btn" :color="'error'" :label="$t('Delete')" @click="deleteUser()" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ButtonAppControl } from '../../atoms';

@Component({
    name: 'TheDeleteDialog',
    components: {
        TheDeleteDialog,
        ButtonAppControl,
    },
})
export default class TheDeleteDialog extends Vue {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: '' }) dialogHeader: string;

    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }
    closeDialog(): void {
        this.$emit('cancel-dialog');
    }
    deleteUser(): void {
        this.$emit('delete-dialog');
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
